import { AbstractControl, ValidationErrors } from '@angular/forms';

export function passwordValidator(control: AbstractControl): ValidationErrors | null {
  const password = control.value;

  // Define the regular expressions for each requirement
  const hasLength = password.length >= 8;
  const hasSpecialCharacter = /[!@#\$%\^&\*]/.test(password);
  const hasCapitalLetter = /[A-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);

  // Check if the password meets all requirements
  const isValid = hasLength && hasSpecialCharacter && hasCapitalLetter && hasNumber;

  // Return validation errors if the password is invalid
  if (!isValid) {
    return { invalidPassword: true };
  }

  // Return null if the password is valid
  return null;
}
